import { range } from "lodash"
import { Sprites } from "../../../utils/Sprites"
import { TtAtlas } from "../TobaccoTourAssets"

export class SmokelessTourAnimations {
    static CHEWING = "CHEWING"
    static SALIVA = "SALIVA"
    static SPITTING = "SPITTING"
    static SWALLOWING = "SWALLOWING"

    static chewing = (
        game: Phaser.Game,
        x: number,
        y: number,
        debug = false,
    ): Phaser.Sprite => {
        const chewing = Sprites.add(game, TtAtlas.CHEWING, { debug, x, y })
        chewing.animations.add(
            SmokelessTourAnimations.CHEWING,
            range(10),
            12,
            true,
        )
        return chewing
    }

    static saliva = (
        game: Phaser.Game,
        x: number,
        y: number,
        debug = false,
    ): Phaser.Sprite => {
        const saliva = Sprites.add(game, TtAtlas.SALIVA, {
            debug,
            x,
            y,
            scale: 1.1,
        })
        saliva.animations.add(SmokelessTourAnimations.SALIVA, range(29), 12)
        return saliva
    }

    static spitting = (
        game: Phaser.Game,
        x: number,
        y: number,
        debug = false,
    ): Phaser.Sprite => {
        const spitting = Sprites.add(game, TtAtlas.SPITTING, { debug, x, y })
        spitting.animations.add("SPITTING", range(10), 12)
        return spitting
    }

    static swallowing = (
        game: Phaser.Game,
        x: number,
        y: number,
        debug = false,
    ): Phaser.Sprite => {
        const swallowing = Sprites.add(game, TtAtlas.SWALLOWING, {
            debug,
            x,
            y,
        })
        swallowing.animations.add("SWALLOWING", range(15), 12)
        return swallowing
    }
}
